/**
 * Centralized user-facing UI messages.
 *
 * Single source of truth for copy that is shown in more than one place. Update
 * the text here and every consumer (pages/components) reflects the change.
 */
export const MESSAGES = {
    RECORD_CREATE_ERROR: 'Failed to create the record',
    RECORD_UPDATE_ERROR: 'Failed to update the record',
    RECORD_DELETE_ERROR: 'Failed to delete the record',
} as const;

export function getErrorMessage(err: any, fallback = 'Something went wrong. Please try again.'): string {
    const msg = err?.message || '';

    if (msg.includes('403') || msg.includes('Forbidden')) {
        return 'You do not have permission to perform this action.';
    }
    if (msg.includes('401') || msg.includes('Not authenticated')) {
        return 'Session expired. Please refresh and try again.';
    }
    if (msg.includes('413') || msg.includes('too large') || msg.includes('Too Large')) {
        return 'File size too large. Please reduce file size and try again.';
    }
    if (msg.includes('500') || msg.includes('Internal Server')) {
        return 'Server error. Please try again later.';
    }
    if (msg.includes('404') || msg.includes('Not Found')) {
        return 'Resource not found.';
    }
    if (msg.includes('400') || msg.includes('Bad Request')) {
        return msg || 'Invalid request. Please check your input.';
    }

    return msg || fallback;
}
